module.exports = __webpack_public_path__ + "static/media/Icons-5.63ea7950.svg";